var WagerTypes = {
  WPS: { name: "wps" },
  WIN: { name: "Win", id: 0 },
  PLACE: { name: "Place", id: 1 },
  SHOW: { name: "Show", id: 2 },
  DAILYDOUBLE: { name: "DailyDouble", id: 7 },
  EXACTA: { name: "Exacta", id: 8 },
  TRIFECTA: { name: "Trifecta", id: 9 },
  QUINELLA: { name: "Quinella", id: 12 },
  SUPERFECTA: { name: "Superfecta", id: 13 },
  PICK3: { name: "Pick3", id: 23, pickNumber: 3 },
  PICK4: { name: "Pick4", id: 24, pickNumber: 4 },
  PICK6: { name: "Pick6", id: 25, pickNumber: 6 },
  HOUSEQ: { name: "HouseQ", id: 33 },
  PICK5: { name: "Pick5", id: 36, pickNumber: 5 },
  PICK7: { name: "Pick7", id: 37, pickNumber: 7 },
  PICK8: { name: "Pick8", id: 38, pickNumber: 8 },
  PICK9: { name: "Pick9", id: 39, pickNumber: 9 },
  PICK10: { name: "Pick10", id: 40, pickNumber: 10 },
  PICK11: { name: "Pick11", id: 41, pickNumber: 11 },
  PICK12: { name: "Pick12", id: 42, pickNumber: 12 },
  HIGH5: { name: "High5", id: 44 },
  OMNI: { name: "Omni", id: 45 },
  GRANDSLAM: { name: "GrandSlam", id: 46 },
  WINPARLAY: { name: "Win Parlay", id: 27 },
  PLACEPARLAY: { name: "Place Parlay", id: 28 },
  SHOWPARLAY: { name: "Show Parlay", id: 29 },
};

export default WagerTypes;
